import { css } from "@emotion/react"

const fontUrl = "/fonts/GothamPro/"

const fontGothamPro = css`
  // @font-face {
  //   font-family: "Gotham Pro";
  //   src: local("GothamPro-Medium"), url("${fontUrl}GothamPro-Medium.woff2") format("woff2");
  //   font-weight: 500;
  //   font-style: normal;
  //   font-display: swap;
  // }

  // @font-face {
  //   font-family: "Gotham Pro";
  //   src: local("GothamPro-Black"), url("${fontUrl}GothamPro-Black.woff2") format("woff2");
  //   font-weight: 900;
  //   font-style: normal;
  //   font-display: swap;
  // }

  // @font-face {
  //   font-family: "Gotham Pro";
  //   src: local("GothamPro-MediumItalic"), url("${fontUrl}GothamPro-MediumItalic.woff2") format("woff2");
  //   font-weight: 500;
  //   font-style: italic;
  //   font-display: swap;
  // }

  // @font-face {
  //   font-family: "Gotham Pro";
  //   src: local("GothamPro-LightItalic"), url("${fontUrl}GothamPro-LightItalic.woff2") format("woff2");
  //   font-weight: 300;
  //   font-style: italic;
  //   font-display: swap;
  // }

  // @font-face {
  //   font-family: "Gotham Pro";
  //   src: local("GothamPro-Light"), url("${fontUrl}GothamPro-Light.woff2") format("woff2");
  //   font-weight: 300;
  //   font-style: normal;
  //   font-display: swap;
  // }

  // @font-face {
  //   font-family: "Gotham Pro";
  //   src: local("GothamPro-Bold"), url("${fontUrl}GothamPro-Bold.woff2") format("woff2");
  //   font-weight: bold;
  //   font-style: normal;
  //   font-display: swap;
  // }

  @font-face {
    font-family: "Gotham Pro";
    src: local("GothamPro"), url("${fontUrl}GothamPro.woff2") format("woff2");
    font-weight: normal;
    font-style: normal;
    font-display: swap;
  }

  // @font-face {
  //   font-family: "Gotham Pro";
  //   src: local("GothamPro-BoldItalic"), url("${fontUrl}GothamPro-BoldItalic.woff2") format("woff2");
  //   font-weight: bold;
  //   font-style: italic;
  //   font-display: swap;
  // }

  // @font-face {
  //   font-family: "Gotham Pro";
  //   src: local("GothamPro-Italic"), url("${fontUrl}GothamPro-Italic.woff2") format("woff2");
  //   font-weight: normal;
  //   font-style: italic;
  //   font-display: swap;
  // }

  // @font-face {
  //   font-family: "Gotham Pro Narrow";
  //   src: local("GothamProNarrow-Bold"), url("${fontUrl}GothamProNarrow-Bold.woff2") format("woff2");
  //   font-weight: bold;
  //   font-style: normal;
  //   font-display: swap;
  // }

  // @font-face {
  //   font-family: "Gotham Pro";
  //   src: local("GothamPro-BlackItalic"), url("${fontUrl}GothamPro-BlackItalic.woff2") format("woff2");
  //   font-weight: 900;
  //   font-style: italic;
  //   font-display: swap;
  // }

  // @font-face {
  //   font-family: "Gotham Pro Narrow";
  //   src: local("GothamProNarrow-Medium"), url("${fontUrl}GothamProNarrow-Medium.woff2") format("woff2");
  //   font-weight: 500;
  //   font-style: normal;
  //   font-display: swap;
  // }
`

export default fontGothamPro
